'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { overlay } from 'overlay-kit';
import { useEffect, useMemo, useRef } from 'react';

import { useRegionSync } from '@/components/common/bottomSheets/region/api';
import { useTokenStore } from '@/store/authToken';
import useMobileStore from '@/store/mobileStore';
import { usePathStore } from '@/store/pathStore';
import { useRegionStore } from '@/store/region';

const DEFAULT_BJD_CD = '1168000000'; // 서울시 강남구 전체

interface DefaultConfigProps {
  headerList: { token: string | null; ssid: string | null; bjdCd: string | null };
}

export default function DefaultConfig({ headerList }: DefaultConfigProps) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const { areaInfo, isHydrated } = useRegionStore();
  const { setToken, setSsid } = useTokenStore();
  const { setPath } = usePathStore();
  const { checkDevice } = useMobileStore();
  const { token, ssid, bjdCd } = headerList;
  const isInitialMount = useRef(true);

  const selectedBjdCd = useMemo(() => {
    const paramValue = searchParams.get('bjdCd');
    let selectedValue;

    if (isInitialMount.current) {
      selectedValue = paramValue || bjdCd || (isHydrated && areaInfo?.bjdCd) || DEFAULT_BJD_CD;
      isInitialMount.current = false;
    } else {
      selectedValue = paramValue || (isHydrated && areaInfo?.bjdCd) || DEFAULT_BJD_CD;
    }
    // console.log('BJD_CD 우선순위:', {
    //   '1.URL params': paramValue,
    //   '2.Header (최초로드)': isInitialMount.current ? bjdCd : 'unused',
    //   '3.저장된지역': areaInfo?.bjdCd,
    //   '→Selected': selectedValue,
    // });

    return selectedValue;
  }, [isHydrated]);

  useRegionSync(selectedBjdCd);

  useEffect(() => {
    overlay.unmountAll();
    setPath(pathname);
  }, [pathname]);

  // 디바이스 체크
  useEffect(() => {
    setToken(token);
    setSsid(ssid);
    checkDevice();
  }, []);

  return <></>;
}
